// test1074
(1074 && 0);
